<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">
            Working Experience
            <a href="#"
              @click="show = true"
              class="btn btn-primary btn-sm btn-rounded float-right">
              <i class="uil-plus"></i>
            </a>
          </div>
          <div class="card-body" style="max-height:500px;overflow-y:scroll">
            <div class="text-center"
              v-if="model.work_experiences.length == 0"
            >No working experience found.</div>

            <div class="list-group" 
              v-for="item in model.work_experiences"
              :key="`item-${item.uiid}`"
            >
              <div class="list-group-item mb-2">
                <div>
                  <h5 class="font-size-15 m-0">{{ item.position }}
                    <a href="#"
                      @click="editExperience( item.uiid )"
                     class="btn btn-primary btn-sm btn-rounded float-right">
                      <i class="uil-pen"></i>
                    </a>
                  </h5>
                  <p class="m-0">{{ item.company }} <span class="text-muted">{{ item.employment_type | capitalize  }}</span></p>
                  <p class="text-muted mb-1">{{ item.start_month | capitalize  }} {{ item.start_year }} - {{ (item.present == true ? "Present" : item.end_month) | capitalize }} {{ item.present == true ? "" : item.end_year }}</p>
                  <p class="sub-header" style="white-space: pre-wrap; max-height:200px;overflow-y:scroll">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">
            Educational Background
            <a 
              href="#"
              @click="showEd = true"
              class="btn btn-primary btn-sm btn-rounded float-right">
              <i class="uil-plus"></i>
            </a>
          </div>
          <div class="card-body">
          <div 
            class="text-center"
            v-if="model.educations.length == 0"
            >No education found.</div>

            <div class="list-group"
              v-for="item in model.educations"
              :key="`item-${item.uiid}`">
              <div class="list-group-item mb-2">
                <div>
                  <h5 class="font-size-15 m-0">{{ item.school  }} {{ item.school_type | capitalize}}
                    <a 
                      href="#"
                      @click="editEducation( item.uiid  )"
                      class="btn btn-primary btn-sm btn-rounded float-right">
                      <i class="uil-pen"></i>
                    </a>
                  </h5>
                  <p class="m-0">{{ item.degree }}</p>
                  <p class="text-muted mb-1">{{ item.start_year }} - {{ item.end_year }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">
            Skills
            <a href="#"
              @click="showSk = true"
               class="btn btn-primary btn-sm btn-rounded float-right">
              <i class="uil-pen"></i>
            </a>
            </div>
            <div class="card-body" style="max-height:300px; overflow-y:scroll">
              <div class="text-center"
                v-if="model.skills.length == 0"
              >No skill/s found.</div>

              <div class="row icons-list font-size-15"
                
              >
                <span 
                  v-for="(item, index) in model.skills"
                  :key="`item-${item.uiid}`"
                  class="font-weight-bold badge badge-soft-secondary m-2">{{item.name}}
                  
                    <button type="button" class="close" style="font-size: 18px;float: none;"
                      @click="removeSkill(index)">
                        <span>×</span>
                    </button>
                  </span>
            </div>
          </div>
        </div>

        <a href="#" class="btn2 btn2-primary btn2-md btn-block mb-4"
          @click="onNext"
        >Proceed and Login</a>

        <div class="text-center">
          <div class="mb-4">OR</div>
          <a
            href="#"
            @click="skipStep"
            class="font-weight-bold"
          >
            Skip Step
          </a>
        </div>
      </div>
    </div>
    
    <b-modal 
      v-model="show" 
      ref="work_experience"
      size="lg" 
      :title="(work_experience.uiid ? 'Edit' : 'Add') + ' Experience'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            placeholder="Enter Position"
            label="Position"
            v-model="work_experience.position"
          />
          <DropDown 
            label="Type"
            :options="employment_type_options"
            :name.sync="work_experience.employment_type"
            v-model="work_experience.employment_type"
          />
          <TextField 
            placeholder="Enter Company"
            label="Company"
            v-model="work_experience.company"
          />
          <TextField 
            placeholder="Enter Country"
            label="Country"
            v-model="work_experience.country"
          />
          <b-form-checkbox
            v-model="work_experience.present"
            class="mb-2">
            I am currently working here
          </b-form-checkbox>
          <div class="row">
            <DropDown 
              label="Start Month"
              class="col-md-3"
              :options="month_options"
              :name.sync="work_experience.start_month"
              v-model="work_experience.start_month"
            />
            <TextField 
              type="number"
              placeholder="Year"
              label="Year"
              class="col-md-3"
              v-model="work_experience.start_year"
            />
            <DropDown 
              label="End Month"
              class="col-md-3"
              :options="month_options"
              :name.sync="work_experience.end_month"
              v-model="work_experience.end_month"
              v-if="!work_experience.present"
            />
            <TextField 
              type="number"
              placeholder="Year"
              label="Year"
              class="col-md-3"
              v-model="work_experience.end_year"
              v-if="!work_experience.present"
            />
          </div>
          <textarea class="form-control" rows="7"
           v-model="work_experience.description"
          ></textarea>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" v-if="work_experience.uiid" @click="removeExperience">Remove</b-button>
        <b-button variant="light" @click="show = false">Close</b-button>
        <b-button variant="primary" @click="addExperience">Add</b-button>
      </template>
    </b-modal>

    <b-modal 
      v-model="showEd" 
      size="lg" 
      ref="education"
      :title="(education.uiid ? 'Edit' : 'Add') + ' Education'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            placeholder="Enter School"
            label="School"
            v-model="education.school"
          />
          <TextField 
            placeholder="Enter Degree"
            label="Degree"
            v-model="education.degree"
          />
          <TextField 
            placeholder="Enter Field of Study"
            label="Field of Study"
            v-model="education.field_of_study"
          />
          <div class="row">
            <TextField 
              type="number"
              placeholder="Year"
              label="Start Year"
              v-model="education.start_year"
              class="col-md-6"
            />
            <TextField 
              type="number"
              placeholder="Year"
              label="End Year"
              v-model="education.end_year"
              class="col-md-6"
            />
          </div>
          <textarea class="form-control" rows="7" placeholder="Enter Description"
           v-model="education.description"
          ></textarea>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" v-if="education.uiid" @click="removeEducation">Remove</b-button>
        <b-button variant="light" @click="showEd = false">Close</b-button>
        <b-button variant="primary" @click="addEducation">Add</b-button>
      </template>
    </b-modal>

    <b-modal 
      v-model="showSk" 
      size="lg" 
      ref="skill"
      :title="(skill.uiid ? 'Edit' : 'Add') + ' Skill'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            placeholder="Enter skill"
            label="Skill"
            v-model="skill.name"
          />
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showSk = false">Close</b-button>
        <b-button variant="primary" @click="addSkill">Add</b-button>
      </template>
    </b-modal>

  </Layout>
</template>

<script>
import Layout from '@layouts/default'
/* import InputTag from 'vue-input-tag' */
import { mapActions } from 'vuex'
import DropDown from '@components/form/dropdown.vue'
import TextField from '@components/form/textfield.vue'
import AuthMixin from '@mixins/auth'

export default {
  mixins: [AuthMixin],
  data(){
    return {
      model:{
        work_experiences:[],
        educations:[],
        skills:[],
        type:'user'
      },
      work_experience:{},
      education:{},
      skill:{},
      show:false,
      showEd:false,
      showSk:false,
      employment_type_options: [
        { value: null, text: '-' },
        { value: 'full-time', text: 'Full-time' },
        { value: 'permanent', text: 'Permenent' },
        { value: 'volunteer', text: 'Volunteer' },
        { value: 'part-time', text: 'Part-time' },
        { value: 'self-employed', text: 'Self-employed' },
        { value: 'freelance', text: 'Freelance' },
        { value: 'contract', text: 'Contract' },
        { value: 'intership', text: 'Internship' }
      ],
      month_options : [
        { value: null, text: '-' },
        {value:'january', text:'January'},
        {value:'february', text:'February'},
        {value:'march', text:'March'},
        {value:'april', text:'April'},
        {value:'may', text:'May'},
        {value:'june', text:'June'},
        {value:'july', text:'July'},
        {value:'august', text:'August'},
        {value:'september', text:'September'},
        {value:'october', text:'October'},
        {value:'november', text:'November'},
        {value:'december', text:'December'}
      ]
    }
  },
  components:{Layout, TextField, DropDown},
  methods:{
    ...mapActions('user', ['findByToken', 'finalize']),
    addExperience(){
      delete this.work_experience._idx
      if(!this.work_experience.uiid){
        this.work_experience.uiid = this.$uuid.v1()
        this.model.work_experiences.push(this.work_experience)
      }
      this.work_experience = {}
      this.show = false
    },
    editExperience(uiid){

      this.model.work_experiences.forEach((el, idx) => {
        if(el.uiid == uiid){
          this.work_experience = el
          this.work_experience._idx = idx
          //this.model.work_experiences.splice(idx, 1)
        }
        return false
      });
      this.$refs['work_experience'].show()

    },
    removeExperience(){
      this.model.work_experiences.splice(this.work_experience._idx, 1)
      this.work_experience = {}
      this.$refs['work_experience'].hide()
    },
    addEducation(){
      delete this.education._idx
      if(!this.education.uiid){
        this.education.uiid = this.$uuid.v1()
        this.model.educations.push(this.education)
      }
      this.education = {}
      this.showEd = false
    },
    editEducation(uiid){

      this.model.educations.forEach((el, idx) => {
        if(el.uiid == uiid){
          this.education = el
          this.education._idx = idx
          //this.model.educations.splice(idx, 1)
        }
        return false
      });
      this.$refs['education'].show()

    },
    removeEducation(){
      this.model.educations.splice(this.education._idx, 1)
      this.education = {}
      this.$refs['education'].hide()
    },

    addSkill(){
      this.skill.uiid = this.$uuid.v1()
      this.model.skills.push(this.skill)
      this.skill = {}
      this.showSk = false
    },
    removeSkill(idx){
      this.model.skills.splice(idx, 1)
      this.skill = {}
    },
    onNext(){
      this.finalize(this.model).then(res => {
        if(res.data.success){
          this.logout()
          this.$router.push('/')
        }
      })
    },
    skipStep(){
      this.onNext()
    }
  },
  mounted() {
    this.findByToken({
      token:this.$route.query.key
    }).then(res => {
      if(res.data){
        this.model.work_experiences = res.data.work_experiences
        this.model.educations = res.data.educations
        this.model.skills = res.data.skills
        this.model.id = res.data.user._id
      }else{
        this.$router.push('/')
      }
    })
  }
}
</script>